import { render } from "./accountActivationSuccess.vue?vue&type=template&id=fe7a1c38&scoped=true"
import script from "./accountActivationSuccess.vue?vue&type=script&lang=js"
export * from "./accountActivationSuccess.vue?vue&type=script&lang=js"

import "./accountActivationSuccess.vue?vue&type=style&index=0&id=fe7a1c38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe7a1c38"]])

export default __exports__